// ============================================================================
// useQueuePingsUnread.js
//
// Live count of the current user's UNREAD Queue Ping deliveries on OPEN pings.
// Single collection-group query over `deliveries` (tenant + uid + status +
// parentStatus) — no parent fan-out reads. Fail-safe to 0.
//
// Combined with useReferralPingsUnread for the single Referral Pings nav badge.
// NO PHI — deliveries are queue-level only.
// ============================================================================

import { useEffect, useState } from 'react';
import { getFirestore, collectionGroup, query, where, onSnapshot } from 'firebase/firestore';
import { getApp } from 'firebase/app';

/**
 * @param {{ tenantId: string|null, uid: string|null }} params
 * @returns {number} count of unread open Queue Ping deliveries for the user
 */
export function useQueuePingsUnread({ tenantId, uid }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!tenantId || !uid) { setCount(0); return; }
    const db = getFirestore(getApp());
    const q = query(
      collectionGroup(db, 'deliveries'),
      where('tenantId', '==', tenantId),
      where('uid', '==', uid),
      where('status', '==', 'UNREAD'),
      where('parentStatus', '==', 'OPEN'),
    );
    const unsub = onSnapshot(
      q,
      (snap) => setCount(snap.size),
      (err) => {
        console.error('[useQueuePingsUnread] snapshot error — count 0:', err?.code || err?.message);
        setCount(0);
      },
    );
    return unsub;
  }, [tenantId, uid]);

  return count;
}
